import {
	array,
	boolean,
	nullable,
	partial,
	record,
	string,
	struct,
	union,
	UnknownRecord,
} from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Type as AddressType } from '../../../address/Type';
import { NewRefItem as BuilderNewRefItem } from '../../../builder/NewRefItem';
import { RefItem as BuilderRefItem } from '../../../builder/RefItem';
import { NewRefItem as CustomerNewRefItem } from '../../../customer/NewRefItem';
import { RefItem as CustomerRefItem } from '../../../customer/RefItem';
import { RefItem as FileType } from '../../../file/RefItem';
import { StructuredIds as AncillaryItemStructuredIds } from '../../../job/ancillary-item/StructuredIds';
import { Id as JobId } from '../../../job/Id';
import { Id as JobTypeId } from '../../../job/job-type/Id';
import { Id as RequestTypeId } from '../../../job/request-type/Id';
import { Id as RequirementId } from '../../../job/requirement/Id';
import { StructuredIds as SubAncillaryItemStructuredIds } from '../../../job/sub-ancillary-item/StructuredIds';
import { Id as OrganizationId } from '../../../organization/Id';
import { NewRefItem as ProjectNewRefItem } from '../../../project/NewRefItem';
import { RefItem as ProjectRefItem } from '../../../project/RefItem';
import { Datetime } from '../../../time/Datetime';
import { Id as TransactionId } from '../../../transaction/Id';
import { Id as UserId } from '../../../user';

/** @deprecated use DatetimeField instead */
const LegacyDatetime = nullable(string);
const DatetimeField = nullable(Datetime);
const LegacyOrNewDatetime = union(LegacyDatetime, DatetimeField);

export const Request = struct({
	job: partial({
		id: JobId,
		//
		// from the 'organization' step
		//

		organizationId: nullable(OrganizationId),

		//
		// from the 'type' step
		//

		jobType: JobTypeId,
		requestType: RequestTypeId,

		//
		// from the 'details' step
		//

		jobName: nullable(string),
		jobRef: nullable(string),

		customer: nullable(union(string, CustomerNewRefItem, CustomerRefItem)),

		project: nullable(union(string, ProjectNewRefItem, ProjectRefItem)),

		builder: nullable(union(string, BuilderNewRefItem, BuilderRefItem)),

		timeline: record(LegacyOrNewDatetime),

		siteAddress: nullable(AddressType),

		customFormData: UnknownRecord,

		salesPersonId: nullable(UserId),

		customerContactId: nullable(UserId),

		iCommandITWJobSync: boolean,

		//
		// from the 'requirements' step
		//

		requirements: array(RequirementId),

		ancillaryItems: iotsUtils.withDefault(AncillaryItemStructuredIds, {}),

		subAncillaryItems: iotsUtils.withDefault(SubAncillaryItemStructuredIds, {}),

		productDetails: nullable(
			partial({
				requirements: UnknownRecord,
				ancillaryItems: UnknownRecord,
			})
		),

		//
		// from the 'transactions' step
		//

		transactionIds: array(TransactionId),

		//
		// from the 'requirements' or 'transactions' step
		//

		notes: nullable(string),

		//
		// from the 'files' step
		//

		files: array(FileType),

		//
		// from the 'pre-processing' step
		//

		// none for now

		//
		// other
		//

		createdAt: string,
	}),
});
